import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import { ConditionType } from "@domain/Vehicle";
import type { IScanEvent, IScanEventDto } from "./IScanEvent";

export class ScanEvent implements IScanEvent
{
    scanEventId: string;
    utcDateScanned: Dayjs;
    conditionType: ConditionType;
    hasIssue: boolean;
    errorCodes?: string[];
    errorCodesUrlEncoded: string = '';
    isTest: boolean = false;

    constructor( model: IScanEventDto )
    {
        this.scanEventId = model.scanEventId;
        this.utcDateScanned = dayjs( model.utcDateScanned );
        this.conditionType = model.conditionType ?? ConditionType.Service;
        this.hasIssue = model.hasIssue;
        this.errorCodes = model.errorCodes;

        if( this.errorCodes?.length ?? 0 > 0 )
        {
            this.errorCodesUrlEncoded = encodeURIComponent( this.errorCodes!.join( '|' ) );
        }

    }

}